import { render } from "./DoctorResultCard.vue?vue&type=template&id=a309cefa&scoped=true"
import script from "./DoctorResultCard.vue?vue&type=script&lang=js"
export * from "./DoctorResultCard.vue?vue&type=script&lang=js"

import "./DoctorResultCard.vue?vue&type=style&index=0&id=a309cefa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a309cefa"]])

export default __exports__